// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.share-directory .Select {
  margin-bottom: 0px;
}


.virtual-table .cell-wrapper.incoming,
.virtual-table .cell-wrapper.incoming span,
.virtual-table .cell-wrapper.incoming strong {
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Share/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;;AAGA;;;EAGE,iBAAiB;AACnB","sourcesContent":[".share-directory .Select {\n  margin-bottom: 0px;\n}\n\n\n.virtual-table .cell-wrapper.incoming,\n.virtual-table .cell-wrapper.incoming span,\n.virtual-table .cell-wrapper.incoming strong {\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
